import { gql } from "@apollo/client";

const ADMIN_ONLY_ACCOUNT_SETTINGS_FIELDS = gql`
  fragment AdminOnlyAccountSettingsFields on Query {
    securityEmail @include(if: $isSaas)
  }
`;

export const GET_ACCOUNT_SETTINGS = gql`
  query GetAccountSettings($isSaas: Boolean = false, $isAdmin: Boolean = false) {
    authorizationScheme
    seats {
      apiKey {
        limit
        inUse
      }
      user {
        limit
        inUse
      }
    }
    ...AdminOnlyAccountSettingsFields @include(if: $isAdmin)
  }
  ${ADMIN_ONLY_ACCOUNT_SETTINGS_FIELDS}
`;
